import { ReactComponent as FavoriteSvg } from '../../assets/icons/favorite.svg';

export const FavoriteIcon: SvgIcon = (props) => {
    return <FavoriteSvg {...props} />;
};
